/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_pin': {
    width: 24,
    height: 29,
    viewBox: '0 0 24 29',
    data: '<path pid="0" d="M23 11.5c0 8.684-9.263 17-11 17s-11-8.316-11-17C1 5.425 5.925.5 12 .5s11 4.925 11 11zm-5.79-.579a5.21 5.21 0 1 1-10.42 0 5.21 5.21 0 0 1 10.42 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_pin.js